module.exports = __webpack_public_path__ + "img/icon24.0480b63.png";